<div class="" *ngIf="chatterDefinition">
    <app-chatter (flowResult)="handleFlowResponse($event)"
                 [commandsList]="chatterDefinition">
    </app-chatter>
</div>
